export const getDateWithoutTime = (date: string): Date => {
  const dateWithoutTime = date.split('T')[0];
  const dateObj = new Date(dateWithoutTime);
  return dateObj;
};
